module.exports = ".form-check-label{\n    font-weight: 600;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/delivery-course-filters/delivery-course-filters.component.css
// module id = ./src/app/shared/components/delivery-course-filters/delivery-course-filters.component.css
// module chunks = main